import { IUser } from "../../interfaces/IUser";
import { Helper } from "../../Helper";
import DateTimeService from "../../services/DateTimeService";
import { ILike } from "../../interfaces/ILike";
import { IMessage, IMessageCategory, IMessageIAMessageBgImagesFromBlob } from "../../interfaces/IMessage";
import { ConditionalOutput } from "../../services/ConditionalOutput";
import { IMessageIAConfiguration } from "../../interfaces/IMessage";

export interface IRotatorServiceProps {
  width: number;
}

export interface IRotatorServiceState {
  selectedCardIndex: number;
}

export interface IRotatorData {
  user?: IUser;
  author?: IUser;
  index?: number;
  tenant?: string;
  component?: string;
  instance?: string;
  token?: string;
  source?: string;
  environment?: "Development" | "Test" | "Production";
  resultSourceId?: string;
  siteCollection?: string;
  listName?: string;
  id?: string;
  item?: any;
  title?: string;
  image?: string;
  iaMessageBgImagesFromBlob?: IMessageIAMessageBgImagesFromBlob;
  iaConfiguration?: IMessageIAConfiguration;
  teaser?: string;
  videoUrl?: string;
  styles?: React.CSSProperties;
  categories?: IMessageCategory[];
  likesEnabled?: boolean;
  commentsEnabled?: boolean;
  modifiedDate?: Date;
  backgroundColor?: string;
  borderColor?: string;
  highlightColor?: string;
  itemTitleColor?: string;
  itemTextColor?: string;
  itemTitleStyle?: string;
  itemTitleSize?: number;
  itemTitleAlign?: string;
  itemTitleWeight?: string;
  timespand?: string;
  onClickOpen?: (content: any) => void;
  commentCount?: number;
  commentsUpdated?: (comments: number) => void;
  commentsClick?: (message: IMessage ) => void;
  likesUpdated?: (likes: ILike[]) => void;
  likes?: ILike[];
  uniqueViewsCount?: number;
  isUnread?: boolean;
  link?: string;
  showPinIcon?: boolean;
}

export interface ICommandBarItem {
  commandTitle: string;
  callback: (content: any) => void;
}

export enum ComponentPresentationType {
  Large,
  Medium,
  Small,
}

export enum ItemPresentationType {
  Large,
  LargeWithoutTeaser,
  Medium,
  Small,
}

export interface IPresentationContext {
  calculatedAltTextColor: string;
  categories: IMessageCategory[];
  modifiedDataAsString: string;
  isSelected: boolean;
  type: ItemPresentationType;
}

export class IARotatorService {
  private readonly dateTimeService: DateTimeService = new DateTimeService();

  public getColor(color: string, context: IPresentationContext) {
    return color ? color : context.calculatedAltTextColor;
  }

  public getPresentationContext(data: IRotatorData, state: IRotatorServiceState, props: IRotatorServiceProps, index: number): IPresentationContext {
    const type: ItemPresentationType = new ConditionalOutput(ItemPresentationType.Large)
      .OnCondition(!data.teaser, ItemPresentationType.LargeWithoutTeaser)
      .OnCondition(props.width < 955, ItemPresentationType.Medium)
      .OnCondition(props.width < 712, ItemPresentationType.Small)
      .Last();

    return {
      calculatedAltTextColor:
        data.backgroundColor !== undefined
          ? Helper.getTextColorBasedOnBackgroundColorDarkness(data.backgroundColor, "#ffffff", "#333333")
          : "#333333",
      categories: data.categories,
      modifiedDataAsString: data.modifiedDate ? this.dateTimeService.ConvertToDDMMYYYY(data.modifiedDate) : undefined,
      type: type,
      isSelected: state.selectedCardIndex === index,
    };
  }

  public getComponentPresentationType(props: IRotatorServiceProps): ComponentPresentationType {
    return new ConditionalOutput(ComponentPresentationType.Large)
      .OnCondition(props.width < 955, ComponentPresentationType.Medium)
      .OnCondition(props.width < 712, ComponentPresentationType.Small)
      .Last();
  }
}
